export interface AppEnv {
  VITE_API_HOST: string;
  VITE_RAVE_PUBLIC_KEY: string;
  VITE_GA_KEY?: string;
}

const env = {
  VITE_API_HOST: window.appEnv?.VITE_API_HOST || import.meta.env.VITE_API_HOST,
  VITE_RAVE_PUBLIC_KEY: window.appEnv?.VITE_RAVE_PUBLIC_KEY || import.meta.env.VITE_RAVE_PUBLIC_KEY,
  VITE_GA_KEY: window.appEnv?.VITE_GA_KEY || import.meta.env.VITE_GA_KEY,
  PUBLIC_URL: import.meta.env.PUBLIC_URL,
  NODE_ENV: import.meta.env.NODE_ENV,
};

export default env;
